import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9.813 8.432.002-.001a.55.55 0 0 1 .777 0l.35-.35-.35.35a.55.55 0 0 1 0 .778l-.001.001-1.548 1.562H8.25V9.98z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.32 3.483a5 5 0 0 0-9.317 2.355L1 6l.002.162A5 5 0 0 0 7 10.899V9.501a.5.5 0 0 1 .148-.356l1.71-1.694a1.55 1.55 0 0 1 1.977-.177 5 5 0 0 0-.515-3.791m-4.652-.357a.5.5 0 0 1 .829.315L6.5 3.5v2.292l1.354 1.354.041.047a.5.5 0 0 1 0 .613l-.041.047-.048.042a.5.5 0 0 1-.612 0l-.048-.041-1.5-1.5-.043-.05a.5.5 0 0 1-.098-.239L5.5 6V3.5l.003-.059a.5.5 0 0 1 .165-.315",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }